import React from 'react';

import Link from 'next/link';

import R2Image from '@/components/ui/R2Image';
import { FooterLink, FooterSection } from '@/data/footerData';
import { resolveMarketingUrl } from '@/constants/routes.mapping';

interface FooterLinksSectionProps {
  section: FooterSection;
}

export const FooterLinksSection: React.FC<FooterLinksSectionProps> = ({
  section,
}) => {
  if (!section.links) return null;
  const renderLink = (link: FooterLink) => (
    <li key={link.id}>
      <Link
        href={resolveMarketingUrl(link.href) || link.href}
        className={
          link.imageUrl
            ? 'block no-underline transition-opacity hover:opacity-80'
            : 'block py-1 text-sm wrap-anywhere wrap-break-word text-gray-200 transition-colors hover:text-white'
        }
        {...(link.isExternal === true && {
          target: '_blank',
          rel: 'noopener noreferrer',
        })}
      >
        {link.imageUrl ? (
          <div className="relative h-12 w-36 max-w-full">
            <R2Image
              path={link.imageUrl}
              alt={link.title}
              objectFit="contain"
              // Container caps out at 144px wide (h-12 w-36) — without this,
              // R2Image's fill-mode default sizes ("100vw" below 640px)
              // requested a far larger image than this footer badge/logo
              // link ever needs. This footer renders on every page, so this
              // was the highest-traffic instance of the pattern.
              sizes="144px"
              className={`object-contain object-left ${link.styles ?? ''}`}
            />
          </div>
        ) : (
          link.title
        )}
      </Link>
    </li>
  );

  return (
    <>
      <ul className="min-w-0 space-y-3 underline">
        {section.links.map(renderLink)}
      </ul>
    </>
  );
};
